import React, { useEffect, useState } from "react";
import { Card, notification, Upload } from "antd";
import { InboxOutlined } from "@ant-design/icons";

import { cfbhAxios } from "utilities/axios";
import config from "../../config.js";

const AdminPage = () => {
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    cfbhAxios
      .get("/documents")
      .then((response) => {
        const files = response.data.map((doc) => ({
          uid: doc.name,
          name: doc.name,
          status: "done",
          url: `${config.apiUrl}/api/documents/${doc.name}`,
        }));
        setFileList(files);
      })
      .catch(() => {
        notification.error({ message: "Failed to fetch documents" });
      });
  }, []);

  return (
    <div style={{ padding: 16, height: "100%" }}>
      <Card title="Documents" style={{ height: "100%" }}>
        <Upload.Dragger
          style={{ width: "100%",  }}
          listType="picture"
          fileList={fileList}
          onChange={({ fileList: newFileList }) => setFileList(newFileList)}
          withCredentials
          action={`${config.apiUrl}/cfbh/api/documents`}
          onRemove={(file) => {
            cfbhAxios
              .delete(`/documents/${file.name}`)
              .then(() => {
                notification.success({
                  message: "Document deleted successfully",
                });
              })
              .catch(() => {
                notification.error({ message: "Failed to delete document" });
              });
          }}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload.
          </p>
        </Upload.Dragger>
      </Card>
    </div>
  );
};

export default AdminPage;
